import { ApiAction, initialApiState, ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface OrderTotalIntervalState extends ApiState {
  total?: number
}

const OrderTotalInterval = (state: OrderTotalIntervalState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<OrderTotalIntervalState>('ORDER_TOTALS')(state, action)
  }
}

export default OrderTotalInterval
